module.exports = __webpack_public_path__ + "img/ic_confirm_solid.9b751303.svg";